(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-announcement"]) return;
  try {
    
// --- Infinite marquee init ---
(function () {
  const SPEED_PX_PER_SEC = 170; // adjust: higher = faster

  // 1) Grab your existing node
  const original = document.querySelector('.announcement-bar-text');
  if (!original) return;

  // 2) Build structure: wrapper (scroller) -> track -> items
  const scroller = document.createElement('div');
  scroller.className = 'announcement-scroller';
  scroller.setAttribute('role', 'marquee');
  scroller.setAttribute('aria-label', original.textContent.trim());

  const track = document.createElement('div');
  track.className = 'announcement-track';

  // Move your existing element inside as the first item
  const item = document.createElement('div');
  item.className = 'announcement-item';
  // Keep original’s classes/styles if you need its background/text styling:
  item.appendChild(original.cloneNode(true));

  // Replace original in DOM with scroller
  original.parentNode.replaceChild(scroller, original);
  scroller.appendChild(track);

  // Add the first item
  track.appendChild(item);

  // 3) Duplicate until width >= 2x scroller width (for seamless loop @ 50%)
  function fillAndSize() {
    // Clear all but the first to avoid infinite growth on resize
    track.querySelectorAll('.announcement-item:not(:first-child)').forEach(n => n.remove());

    // Measure with the first item present
    const scrollerWidth = scroller.clientWidth;
    const firstWidth = track.scrollWidth;

    // If first item has inner wrapper, use its width for accuracy
    let contentWidth = firstWidth;
    // Duplicate until we reach at least 2x (so animation can translate -50%)
    while (track.scrollWidth < scrollerWidth * 10) {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
      contentWidth = track.scrollWidth;
      if (track.children.length > 50) break; // safety cap
    }

    // 4) Set duration from distance (50% of track width) and speed
    const halfDistance = track.scrollWidth / 2; // we animate -50%
    const durationSec = Math.max(halfDistance / SPEED_PX_PER_SEC, 6); // min 6s for comfort
    track.style.setProperty('--ann-duration', `${durationSec}s`);
  }

  // Initial fill
  fillAndSize();

  // Recompute on resize (debounced)
  let t;
  window.addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(fillAndSize, 150);
  }, { passive: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product-recommendations-two"]) return;
  try {
    
$( document ).ready(function() {
$( "body" ).addClass( "modal-off" );
setTimeout(function(){
$( "body .prod-recom-two li" ).each(function( index ) {
$( this ).find( ".productitem--action-trigger" ).trigger( "click" );
});
}, 4000);
setTimeout(function(){
$( ".modal-loaded .modal" ).each(function( index ) {
$( ".modal-close" ).trigger( "click" );
});
$( "body" ).removeClass( "modal-off" );
}, 5000);
});

  } catch(e) { console.error(e); }
})();
})();
